import { ContentStatusName } from 'tno-core';

export const PublishedStatuses = [ContentStatusName.Publish, ContentStatusName.Published];
